export const getBrowserLocale = (): string => {

  // zh-CN -> zh_CN
  return window.navigator.language.replace('-', '_');
};
